import { render, staticRenderFns } from "./AppMemberReviewsListWithReply.vue?vue&type=template&id=0e20273d&scoped=true&"
import script from "./AppMemberReviewsListWithReply.vue?vue&type=script&lang=js&"
export * from "./AppMemberReviewsListWithReply.vue?vue&type=script&lang=js&"
import style0 from "./AppMemberReviewsListWithReply.vue?vue&type=style&index=0&id=0e20273d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e20273d",
  null
  
)

export default component.exports